import { useReducedMotion } from "framer-motion";

/**
 * The `initial` prop for an entrance animation, or `false` when the user
 * prefers reduced motion.
 *
 * Entrance states start at `opacity: 0`. Reduced motion only skips the
 * transform half, so content would still blank out and fade in. `false` tells
 * framer to render at the target state right away, and propagates that state
 * to child variants so staggered lists appear at once.
 */
export function useMotionInitial<T>(initial: T): T | false {
  return useReducedMotion() ? false : initial;
}
